import classNames from "classnames";
import HomeGarageLabel from "./HomeGarageLabel";
import homeGarageStyles from "./StyledHomeGarage.module.scss";
import VehicleDescription from "./VehicleDescription";
import styles from "./homeGarageVehicleSelected.module.scss";

function HomeGarageRegularVehicleSelected(props) {
  const {
    isCompactGarage, onChangeVehicle, fitmentOptionsDetails, fitmentOptionsPrompt,
  } = props;

  return (
    <div className={`home-garage ${homeGarageStyles.StyledHomeGarage}`}>

      <div className={classNames({
        [styles.compact_vehicle]: isCompactGarage,
      })}
      >

        <HomeGarageLabel isCompactGarage={isCompactGarage} />
        <div className="garage">

          <VehicleDescription
            isCompactGarage={isCompactGarage}
            onChangeVehicle={onChangeVehicle}
            fitmentOptionsDetails={fitmentOptionsDetails}
            fitmentOptionsPrompt={fitmentOptionsPrompt}
          />

        </div>
      </div>
    </div>
  );
}

export default HomeGarageRegularVehicleSelected;
